import React , { useEffect , useState  , useRef} from 'react'

import { Control, useFieldArray, useForm, useWatch } from "react-hook-form";




import './styles3.css' //


import {ApiCallGet , ApiCallPost } from '../../Components/ApiCall/ApiCall'



export default function ConfiguradorForm3() {

  const [options,setOptions] = useState([])
  const [clave,setClave] = useState("")
  const [codigoagrupador,setCodigoAgrupador] = useState( "" ) ;
  const [busqueda,setBusqueda] = useState("")
  const [tasaCuota,setTasaCuota] = useState([])
  const [original,setOriginal] = useState([])

  
  


  function onSubmit( data )
  {
    console.log( "onSubmit " , data )

    var caso = {
      nombre : data.factura.caso ,
      comentario : data.factura.comentario ,
      rfc :( document.getElementById(`rfc`).value === "1" ? 1 : 0 ) ,
      dTimeStamp : new Date()
    }

    var cuentas = [] ; // este es el arreglo de cuentas


    //console.log( "length = " , data.factura.filtro.length )

    for( var i = 0 ; i < data.factura.filtro.length ; i++ )
    {

      console.log( "impuesto** = " , document.getElementById( `impuesto${i}`).value )

      //return 

      var sufix = getSufixData( document.getElementById( `sufijo${i}`).value )

      var codigo = getTheCodigo( document.getElementById(`cuenta${i}`).value )

      

      var cuenta = {

        claveproductoserv : data.factura.filtro[i].clave.split('-')[0].trim() ,
        filtro_campo :  ( data.factura.filtro[i].campo === "1" ? "Descripcion" : "NoImpuesto" ),
        filtro_valores : data.factura.filtro[i].valores ,
        tag : codigo.nombre ,
        codigo : codigo.codigo ,// getTheCodigo( data.factura.filtro[i].cuenta ) ,
        impuesto : document.getElementById( `impuesto${i}`).value  ,
        sufix : sufix.caracter  ,
        prefix : '' ,
        descripcion : '' ,
        tasa : sufix.valormaximo ,
        dTimeStamp : new Date() 

      }

      cuentas.push( cuenta ) ;

      var body = {
        caso : caso ,
        cuentas : cuentas 
      }
    }

    console.log( "cuentas = " ,  body )

    ApiCallPost( "savecaso" , body )
    .then( ( response ) => {
      console.log( "response = " , response )



      
    })
    .catch(( error ) =>{
      console.log( error )
    })

  }

  function getSufixData ( id )
  {

    var id2 = parseInt( id )

    console.log( "id2 = " + id2  )

    for( var i = 0 ; i < original.length ; i++ )
    {
      console.log( "idcattasacuota " ,  tasaCuota[i].idcattasacuota )

      if ( id2 === original[i].idcattasacuota )
      {

        
        var obj = {
          caracter :  original[i].caracter ,
          valormaximo : original[i].valormaximo
        }

        console.log( "obj = " , obj )

        return obj ;

      }
    }

  }

  function getTheCodigo( id )
  {

    console.log( "id = " + id )

    var id2 =  parseInt( id )

    for( var i = 0 ; i < codigoagrupador.length ; i++ )
    {

      console.log( "idcatcodigoagrupador = " + codigoagrupador[i].idcatcodigoagrupador )
        if ( id2 ===  codigoagrupador[i].idcatcodigoagrupador )
        {
          var obj = {
            codigo : codigoagrupador[i].codigo ,
            nombre : codigoagrupador[i].nombre 
          }

          return  obj ; // Regresamos el que encontramos // nombre

        }


    }

    return null ;
  }

  

  function onError(errors)
  {
    console.log( "onError " , errors)



      var filtro =  getValues( 'factura.filtro') // Obtenemos el objeto filtro

      var canSave = true ; // Ya podemo guardar el registro ???


      if ( errors.factura.hasOwnProperty('caso'))
      {
        console.log( "Falta caso")
        canSave = false ;
      }

      if ( errors.factura.hasOwnProperty('comentario'))
        {
          console.log( "Falta comentario")
          canSave = false ;
        }
  

      console.log( "filtro length = " + filtro.length ) ;

      var myFilter = [] ;

      
      

      for( var i = 0 ; i < filtro.length ; i++ )
      {

        console.log( "i = " + i ) ;

        var n = 0 ;

        if ( errors.factura.filtro[i] === undefined || errors.factura.filtro[i] === null)
        {
          console.log( "Ya se puede guardar")
        }
        else {

            n = Object.keys(errors.factura.filtro[i]).length; // Cuantos elementos tiene este objeto

            console.log( "n = " + n )

            if ( n > 3 )
            {
              canSave = false  ;
            }
        
          var clave = document.getElementById(`descripcion${i}`).value ;

          console.log( "clave = " + clave ) ;

          if ( errors.factura.filtro[i].hasOwnProperty('descripcion'))
          {
            if ( clave === "")
            {
              console.log( "No se tiene clave")
              canSave = false ;
            }
          }

          var cuenta = document.getElementById(`cuenta${i}`).value ;

          console.log( "cuenta = " + cuenta ) ;

          if ( errors.factura.filtro[i].hasOwnProperty('cuenta'))
          {
            if ( cuenta === "")
            {
              console.log( "No se tiene cuenta")
              canSave = false ;
            }
          }
    

          var sufijo = document.getElementById(`sufijo${i}`).value ;

          console.log( "sufijo = " + sufijo )

          if ( errors.factura.filtro[i].hasOwnProperty('sufijo'))
            {
              if ( sufijo === "")
              {
                console.log( "No se tiene sufijo")
                canSave = false ;
              }
            }
    

    

        }

      }

          if ( canSave === false )
          {
            console.log( "Faltan campos por capturar")
          }
          else{
            console.log( "Ya se puede guardar")
          }
          


  }


  function loadTasaCuota()
  {


    ApiCallGet('gettasacuota')
    .then( (result) => {

      console.log( "getTasaCuota =" , result )


      var arr = []


      for( var i = 0 ; i < result.length ; i++ )
      {
          var obj = {
            value : "" ,
            label : ""
          }


          var rango = ( result[i].rangoofijo === "Rango" ? true : false )

          obj.value =  result[i].idcattasacuota ;
          obj.label =  result[i].caracter + " , " + result[i].rangoofijo +  (  rango === false ? " = " : " ")  +
             (result[i].valorminimo === null ? '  ' : result[i].valorminimo + ( rango === true ? " a " : " , " ))  + result[i].valormaximo  + " , " + result[i].impuesto;
          


          arr.push( obj ) ;

      }


      setTasaCuota( arr ) ;
      setOriginal( result )

    })
    .catch((err) => {

      console.log( err ) ;

    })


  }


  function isImpuesto( index )
  {
    console.log( "isImpuesto = " + index )

    const values = getValues( [`factura.filtro.${index}.impuesto`])

    console.log( "impuesto = " , values ) ;

    if ( values[0] === "1") // Si se paga impuesto
    {
        return true ;
    }
    else{
      return false ; 
    }
  }

  function onChangeImpuesto(index  )
  {
      console.log( "onChangeImpuesto " + index )
      //factura.filtro.${index}.tasa

      //var element = document.getElementById( `factura.filtro.${index}.tasa`)


      // factura.filtro.${index}.impuesto

      //var impuesto  = document.getElementById( `factura.filtro.${index}.impuesto`).value ;


      const values = getValues( [`factura.filtro.${index}.impuesto`])

      console.log( "impuesto = " , values ) ;

      if ( values[0] === "1") // Si se paga impuesto
      {

      }


  }

  function onchangetCuenta(index)
  {
    console.log( "onChangeCuenta") ;

    var cuentaName = document.getElementById(`tag${index}`).value ;

    console.log( "cuentaname = " + cuentaName )

    if ( cuentaName.length > 3 )
    {

      var selectElement = document.getElementById(`cuenta${index}`)

      console.log( "Entrando por codigo agrupador")

      removeAll(selectElement)

      ApiCallGet('getCodigoAgrupador/?parms=' + cuentaName )
        .then( (response) => {

          console.log( "CodigoAgrupador =" , response )

          // idcatcodigoagrupador , codigo

          setCodigoAgrupador( response )

          for( var i = 0 ; i< response.length ; i++ )
          {

              if ( i === 0 )
              {
                  setValue(`factura.filtro.${index}.cuenta` , response[i].idcatcodigoagrupador )
              }

              const newOption = document.createElement('option');
              const optionText = document.createTextNode( response[i].codigo + "=>" + response[i].nombre);
              newOption.appendChild(optionText);
              newOption.setAttribute('value', response[i].idcatcodigoagrupador );
              selectElement.add( newOption )


        }



        }).catch((err) => {

        })

      
    }
  }

  function getNameFromIndex( index )
  {
    var codigo = watch(`factura.filtro.${index}.codigo`) ;

    for( var i = 0 ; i < codigoagrupador.length ; i++ )
    {
      if ( codigoagrupador[i].value === codigo ){
          return codigoagrupador[i].nombre ; 
      }
    }
  }

  function onSetBusqueda( value )
  {

    var bus = document.getElementById("busqueda").value

    console.log( "onSetBusqueda = " + bus  )

    setBusqueda( bus )
  }

  useEffect(() => {

    console.log( "Busqueda*** = " + busqueda )

  } ,[busqueda])

  function removeAll(selectBox) {

    //if ( selectBox === null ) return ;

  

    while (selectBox.options.length > 0) {
        selectBox.remove(0);
    }
}

  function onBuscar ( index   ){


    var theBusqueda = document.getElementById(`buscar${index}`).value

    console.log( "onBuscar index = " , index  , theBusqueda ) ;

    //setValue( `factura.filtro.${index}.descripcion2`  , "Hola Amigo" )


    //return ;


    theBusqueda = theBusqueda.trim() ;

    if ( theBusqueda.length > 3 )
    {
        console.log( " Nos vamos a la busqueda")

        var parms = ""


        parms = theBusqueda.split( " ") ;

        var selectElement = document.getElementById( `descripcion${index}`)

        if ( selectElement === undefined || selectElement === null )
        {
          console.log( "No se encontro el selectElement **************")
        }
    

        ApiCallGet('getprodserv/?parms=' + parms )
        .then( (response) => {

          console.log( "CodigoAgrupador =" , response )

          var theOptions = []

          removeAll( selectElement )

        for( var i = 0 ; i < response.length ; i++ )
        {
          var option = {}

          option.value = response[i].id_claveprodserv ;
          option.label = response[i].c_claveProdServ  + " - " + response[i].descripcion ;


          // factura.filtro.${index}.clave`

          if ( i === 0 ) // Establecemos el primer elemento
          {
            setValue(`factura.filtro.${index}.clave`  , option.value )
          }


          //selectElement.add(new Option(option.value, option.label));

          const newOption = document.createElement('option');
          const optionText = document.createTextNode(option.label);
          // set option text
          newOption.appendChild(optionText);
// and option value
          newOption.setAttribute('value', option.label);

          selectElement.add( newOption )

          theOptions.push( option ) ;

        }

        setOptions( theOptions )

      }).catch((err)=>{
        console.log( err )
      })
    }

  } 


        const {
            register,
            formState: { errors },
            handleSubmit,
            //setError ,
            watch,
            setValue ,
            getValues ,
            control
          } = useForm({
            defaultValues: {
              factura: { 
                caso : "" , 
                campo: "" ,
                valore : ""  ,
                descripcion : "" ,
                filtro :[ 
                  {
                    claveprod : "" ,
                    clave : "" ,
                    campo : "" ,
                    valores : "" ,
                    tag : "" ,
                    codigo : "" ,
                    tagdesc : "" ,
                    descripcion2 : "" ,
                    impuesto : "" ,
                    tasa :"" ,
                    sufijo : "" ,
                    prefijo : "" 
                  }
                ]
              } 
            }
          });
          const { fields, append, prepend, remove   } = useFieldArray({
            name: "factura",
            control,

          });

          

          function getDescripcion()
          {
            var factura = watch( 'factura.descripcion')

            console.log( "descripcion2 = " + factura )

            return factura ;
          }

          var factura = watch( 'factura.filtro' )

          console.log( "factura = " + JSON.stringify( factura ) )

          if ( clave !== watch('factura.descripcion'))
          {
            console.log( "Cambiando clave")
            setClave( watch('factura.descripcion') )
            //setClave( "Samuel")
          }
            

          useEffect(() =>{
              console.log( "Cambio de clave = " + clave )
          } ,[clave])

          console.log( "Comentario = " + watch( 'factura.comentario'   ) )  

 
          // function cambioFiltro()
          // {

          //   console.log( "Se detecto cambio de filtro2") ;

          //   for( var i = 0 ; i < `factura.filtro`.length ; i++)
          //   {
          //     console.log( `factura.filtro.${i}.codigo` )
          //   }

          // }



          // function test()
          // {
            
          //   console.log( "Por function")

          //   var factura = watch('factura')

          //   //var clave = getValues( 'filtro.descripcion')

          //   if ( factura.descripcion === clave)
          //   {
          //     return ;
          //   }

          //   setClave( factura.descripcion)


          //   console.log( "clave = ", factura.descripcion ) ;

          //   if ( factura.filtro === undefined )
          //   {
          //     return ;
          //   }

          //   for( var i = 0 ;  i < factura.filtro.length ; i++ )
          //   {
          //      setValue(`factura.filtro.${i}.codigo` , factura.descripcion )
          //   }
          // }

 

          // test() ;

          function getCodigoAgrupador()
          {

          

            ApiCallGet('getcodigoagrupador/?parms=')
            .then( (result) => {
        
              console.log( "CodigoAgrupador =" , result )
        
        
              var arr = []
        
        
              for( var i = 0 ; i < result.length ; i++ )
              {
                  var obj = {
                    value : "" ,
                    label : ""
                  }
        
        
                  obj.value =  result[i].codigo ;
                  //obj.label =  result[i].codigo ;
                  obj.nombre = result[i].nombre ;
        
        
                  arr.push( obj ) ;
        
              }
        
              //setCodigoAgrupador( arr ) ;
        
        
            })
            .catch((err) => {
        
              console.log( err ) ;
        
            })
        
        
          } 
        


          useEffect(() =>{


           //setValue( "factura.caso" , "caso")
          //  setValue( "factura.claveprod" , "claveprod")
          //  setValue("factura.filtro.0.clave" , "clave")
          //  setValue("factura.filtro.0.valores" , "valores")

          console.log( "Por useEffect")

           var factura = watch('factura')

           //var clave = getValues( 'filtro.descripcion')

           console.log( "clave = ", factura.descripcion ) ;

           //getCodigoAgrupador()

           loadTasaCuota() 



          //  for( var i = 0 ;  i < factura.filtro.length ; i++ )
          //  {
          //     setValue(`factura.filtro.${i}.codigo` , factura.claveprod )
          //  }

           } , [] )


          // function handleSubmit(e)
          // {
          //   e.preventDefault() ;
          // }

          // React.useEffect(() => {
          //   setError("clave", {
          //     type: "required",
          //     message: "Este campo es obligatorio",
          //   } )
          // }, [setError])

          // value={getNameFromIndex(index)}
          // {...register(`factura.filtro.${index}.codigo`, { required: "El campo codigo es requerido"})}
  return (
    <div style={{ height:'100vh' , width : '80%' , 
        color : 'black' ,  margin : 'auto' ,
        border :'1px' , borderStyle :'solid' }}>
    {/* <Headers
      renderCount={renderCount}
      description="Performant, flexible and extensible forms with easy-to-use validation."
    /> */}

        <div style={{width:'90%' , marginLeft : '20px' , color :'black' , alignContent :'center'}}>

        <div className='form-group'  >

          <div className='row '>
            

              <div className='col-4'>
                            
                <label htmlFor='caso'>Caso</label>
                <input class="form-control" style={{width:'100%'}} id='caso'
                  {...register('factura.caso', { required : "Caso campo requerido" }
                    
                  )}
                />
              </div>  

            


            

            <div className='col-4'>

            

              <label htmlFor={`rfc`}>RFC</label>
              <select  className='w-100'   id={`rfc`}
                    {...register(`factura.rfc`, { required: "Campo requerido"})}
                    style={{height:'36px' , borderRadius : '5px'}}>
                                <option value="0" >Seleccione Opción</option>
                                <option value="1">Si</option>
                                <option value="2">No</option> </select>

                  {/* { errors.factura?.filtro[index].rfc && <p className='errtype'>
                          {errors.factura?.filtro[index].rfc.message}</p>}    */}
             {/*  <label htmlFor='prefijo'>Prefijo</label>
                <input class="form-control" style={{width:'100%'}} id='prefijo'
                {...register(`factura.filtro.${index}.prefijo`, { required: false })}
              />*/}
            


            </div>

            <div className='col-4'>
              <label htmlFor='comentario'>Comentario</label>
              <input class="form-control" style={{width:'100%'}} id='comentario'
                {...register('factura.comentario', { required: "Comentario , campo requerido" })}
              />

            </div>
            



          </div>   

         
          <div className='row'>

            <div className='col-4 errtype'>
              {errors.factura?.caso && <p role="alert">{errors.factura?.caso.message}</p>}
            </div>
            <div className='col-4'>

            </div>

            <div className='col-4 errtype'>
              {errors.factura?.comentario && <p role="alert">{errors.factura?.comentario.message}</p>}
            </div>


          </div>

          
          
        

        </div>

        <div >




        </div>
        </div>

        <hr/>

    <div style={{width:'97%' , margin : '20px' , color :'black'  ,  overflowY:'auto' , height : '550px' }}>

      
    <form
      onSubmit={handleSubmit(onSubmit,onError)}
    >
      {fields.map((field, index) => {
        return (
          <>
          <hr/>



          <div className='row mt-2'>

          <div className='col-3 mt-0'>

            <label htmlFor={`buscar${index}`}>Busqueda de Clave Producto</label>

            <input class="form-control" style={{width:'100%'}} id={`buscar${index}`} 
              onChange={()=>onBuscar(index  )} />  
              {/*{...register(`factura.filtro.${index}.buscar`,{required:false})} */}
              {/* <div className=' text-center' style={{height:'28px' }}>
                <button style={{borderRadius:'5px' , marginBottom : '0px', paddingLeft :'0px' , 
                 width:'50px' ,fontSize :'12px'  }} onClick={openModal} 
                  type='button'>
                  Buscar
                </button>

              </div> */}

          </div>



            <div className='col-3'>

              <label  htmlFor={`descripcion${index}`}>Clave de Producto Servcicio</label>

                <select id={`descripcion${index}`} style={{width:'100%' , height:'35px' , borderRadius :'5px'}}
                  {...register(`factura.filtro.${index}.clave`, { required: "El campo decripcion es requerido" })}
                ></select>
                
                {/* <input class="form-control" style={{width:'100%'}} id={`descripcion${index}`}
                {...register(`factura.filtro.${index}.descripcion2`, { required: "El campo decripcion es requerido" })}
              />  */}


            </div>



            <div className='col-2'>
            <label htmlFor='campo'>Campo de XML</label>
            <select  className='w-100' id='descripcion' defaultValue={'0'} 
              {...register(`factura.filtro.${index}.campo`, { required: "Campo requerido"})}
              style={{height:'32px' , borderRadius : '5px'}}>
                          <option  value='0'>Seleccione Opción</option>
                          <option value="1">Descripcion</option>
                          <option value="2">No ID</option> </select>


                



            </div>

            <div className='col-2 '>

              <label htmlFor='valores'>Valor del Campo</label>
                <input class="form-control" style={{width:'100%'}} id='valores'
                {...register(`factura.filtro.${index}.valores`, { required: "El campo Valores es requerido" })}
              />


            </div>


            <div className='col-1 mt-2'>
              <div className=' text-center' style={{height:'28px' }}>
                <button style={{borderRadius:'5px' , marginBottom : '0px', paddingLeft :'0px' , 
                 width:'50px' ,fontSize :'12px' }} onClick={(index) => remove(index)}
                  type='button'>
                  Borrar
                </button>

              </div>

            </div>


          </div>

          <div className='row'>

            <div className='col-4'>

            </div>


            <div className='col-3'>         
              { errors.factura?.filtro[index]?.campo && <p className='errtype'>
              {errors.factura?.filtro[index]?.campo.message}</p>}
            </div>

            <div className='col-4'>

              { errors.factura?.filtro[index]?.valores && <p className='errtype'>
              {errors.factura?.filtro[index]?.valores.message}</p>}

            </div>


          </div>
          

          <div className='row'>


            <div className='col-3'>

              <label htmlFor={`tag${index}`}>Busqueda Cuenta Contable</label>
                <input class="form-control" style={{width:'100%'}}  id={`tag${index}`} 

                onChange={() => onchangetCuenta(index)  } />

            

            </div>

 
            <div className='col-9'>

              <label htmlFor={`cuenta${index}`}>Cuenta Contable</label>
                <select class="form-control" style={{width:'100%'}} id={`cuenta${index}`}
                  {...register(`factura.filtro.${index}.cuenta`, { required: "El campo Valores es requerido" })}

                >
                    
                  

                </select>
              


            </div>






          </div>


          {/* <div className='row'>

            <div className='col-4'>
              { errors.factura?.filtro[index].tag && <p className='errtype'>
              {errors.factura?.filtro[index].tag.message}</p>}
            </div>


            <div className='col-4'>   
              { errors.factura?.filtro[index].codigo && <p className='errtype'>
              {errors.factura?.filtro[index].codigo.message}</p>}      

            </div>

            <div className='col-4'>




            </div> 


          </div>*/}



          <div className='row'>




            <div className='col-3'>

                  <label htmlFor={`impuesto${index}`}>Impuesto</label>
                  <select  className='w-100' id={`impuesto${index}`} onChange={onChangeImpuesto(index )}
                    {...register(`factura.filtro.${index}.impuesto`, { required: "Campo requerido"})}
                    style={{height:'32px' , borderRadius : '5px'}}>
                                <option value="0" >Seleccione Opción</option>
                                <option value="1">Si</option>
                                <option value="2">No</option> </select>
{/* 
                  { errors.factura?.filtro[index].impuesto && <p className='errtype'>
                          {errors.factura?.filtro[index].impuesto.message}</p>}    */}
            </div>

            {/* <div className='col-3'>

              <label htmlFor='tasa'>Tasa</label>
                <input class="form-control" style={{width:'100%'}} id='tasa' readOnly={()=>isImpuesto(index)}
                {...register(`factura.filtro.${index}.tasa`, { required: true })}
              />            
              { errors.factura?.filtro[index].tasa && <p className='errtype'>
                      {errors.factura?.filtro[index].tasa.message}</p>}   

            </div> */}


    

            <div className='col-6'>

              <label htmlFor={`sufijo${index}`}>Sufijo</label>
              <select id={`sufijo${index}`} style={{width:'100%', height:'36px',borderRadius:'5px'}}
                {...register(`factura.filtro.${index}.sufijo`, { required: true })}>
                {
                  tasaCuota.map((val,index) =>(
                    
                    <option value={val.value}>{val.label}</option>
                  )

                   )
                }

              </select>
                {/* <input class="form-control" style={{width:'100%'}} id='sufijo'
                {...register(`factura.filtro.${index}.sufijo`, { required: true })}
              /> */}
            </div>






          </div>

          </>
        );
      })}


      <div className='divlinea' style={{width:'50%' , 
        margin :'auto' , display :'flex' , justifyContent :'space-between' , marginTop : '20px'}}>

      

      
      <button
        type="button"
        onClick={() => {
          append({
            clave :"" ,
            campo :"" ,
            valores : ""
             ,
            // clave : "" ,
            // campo : "" ,
            // valores : "" ,
            // tag : "" ,
            // codigo : "" ,
            // tagdesc : "" ,
            // descripcion2 : "" ,
            // impuesto : "" ,
            // tasa :"" ,
            // sufijo : "" ,
            // prefijo : "" 
          });
        }}
      >
        Append
      </button>
      <button
        type="button"
        onClick={() => {
          prepend({
            clave: "",
            campo: "" ,
            valore : "" 
          });
        }}
      >
        prepend
      </button>

      </div>

      {/* <TotalAmout control={control} /> */}

      
      <div style={{marginTop:'20px'}}>
        <button style={{width:'50%' , margin :'auto'}} type="submit">Submit</button>
      </div>
      
    </form>
    </div>
  </div>

  )
}
